import { useMemo } from 'react';
import MessageItem from './MessageItem';
import { aiChatShell } from '../../../styles/aiChatShell';

/**
 * メッセージリストコンポーネント
 */
export default function MessageList({
    messages,
    loading,
    purging,
    showLoadingIndicator,
    showTurn,
    onEdit,
    messagesBoxRef
}) {
    // メッセージリストをメモ化（不要な再レンダリングを防止）
    const memoizedMessages = useMemo(() => {
        return messages.map((m, idx) => ({
            ...m,
            key: m.id ? `${m.role}-${m.id}` : `msg-${idx}`,
            isLastMessage: idx === messages.length - 1
        }));
    }, [messages]);

    if (purging) {
        return (
            <div className={aiChatShell.messages} ref={messagesBoxRef}>
                <div className={`${aiChatShell.msgAi} ${aiChatShell.msgCentered}`}>
                    <div className={aiChatShell.typing}>
                        <span>新しいチャットを準備中</span>
                        <span className={aiChatShell.typingDots}>
                            <span className={aiChatShell.dot}></span>
                            <span className={aiChatShell.dot2}></span>
                            <span className={aiChatShell.dot3}></span>
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    if (messages.length === 0) {
        return null; // 空の場合は親コンポーネントで処理
    }

    return (
        <div className={aiChatShell.messages} ref={messagesBoxRef}>
            {memoizedMessages.map((m, idx) => (
                <MessageItem
                    key={m.key}
                    message={m}
                    index={idx}
                    isLastMessage={m.isLastMessage}
                    loading={loading}
                    purging={purging}
                    onEdit={onEdit}
                    showTurn={showTurn}
                />
            ))}
            {loading && showLoadingIndicator && (
                <div className={aiChatShell.msgAi}>
                    <div className={aiChatShell.typing}>
                        <span>AIが回答中</span>
                        <span className={aiChatShell.typingDots}>
                            <span className={aiChatShell.dot}></span>
                            <span className={aiChatShell.dot2}></span>
                            <span className={aiChatShell.dot3}></span>
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
}
